import { render, staticRenderFns } from "./MPlayVideo.vue?vue&type=template&id=21b10b7b&scoped=true&"
import script from "./MPlayVideo.vue?vue&type=script&lang=js&"
export * from "./MPlayVideo.vue?vue&type=script&lang=js&"
import style0 from "./MPlayVideo.vue?vue&type=style&index=0&id=21b10b7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b10b7b",
  null
  
)

export default component.exports